import { useState } from 'react';
import { formatarDocumento } from '@raiox/domain';
import { Logo } from './Logo.js';
import { trpc } from '../lib/trpc.js';
import { aplicarTema, lerTema, proximoTema, ROTULO_TEMA, type Tema } from '../lib/tema.js';
import type { Sessao } from '../lib/tipos.js';

export function Cabecalho({ sessao }: { sessao: Sessao }) {
  const utils = trpc.useUtils();
  const [tema, setTema] = useState<Tema>(() => lerTema());

  const sair = trpc.auth.sair.useMutation({
    onSuccess: () => {
      void utils.invalidate();
    },
  });

  const trocar = trpc.auth.trocarEmpresa.useMutation({
    onSuccess: () => {
      // Empresa nova, dados novos: nada do cache anterior continua válido.
      void utils.invalidate();
    },
  });

  const ativa = sessao.empresas.find((e) => e.id === sessao.empresaAtiva);

  return (
    <header className="mast">
      <div className="wrap">
        <div>
          <Logo produto="Raio-X Fiscal" />
          <p>
            Leitura de XMLs de NF-e, NFC-e, NFS-e e CT-e: separa ICMS, PIS, COFINS, IBS e CBS, destaca as
            retenções de ISS e INSS e amarra cada documento ao CNO da obra.
          </p>
        </div>

        <div className="mast-actions">
          {sessao.empresas.length > 1 ? (
            <label>
              <span style={{ position: 'absolute', left: '-9999px' }}>Empresa ativa</span>
              <select
                value={sessao.empresaAtiva}
                disabled={trocar.isPending}
                onChange={(e) => trocar.mutate({ empresaId: e.target.value })}
              >
                {sessao.empresas.map((empresa) => (
                  <option key={empresa.id} value={empresa.id}>
                    {empresa.razaoSocial}
                  </option>
                ))}
              </select>
            </label>
          ) : null}

          <div className="quem">
            <strong>{sessao.usuario.nome}</strong>
            {ativa ? `${formatarDocumento(ativa.cnpj)} · ${ativa.papel}` : sessao.papel}
          </div>

          <button
            type="button"
            className="btn sm"
            title={ROTULO_TEMA[tema]}
            onClick={() => {
              const novo = proximoTema(tema);
              aplicarTema(novo);
              setTema(novo);
            }}
          >
            {ROTULO_TEMA[tema]}
          </button>

          <button type="button" className="btn sm" disabled={sair.isPending} onClick={() => sair.mutate()}>
            Sair
          </button>
        </div>
      </div>
    </header>
  );
}
